import { ThemeColors } from '../types';

export const candidateColorScheme: ThemeColors = {
  errors: {
    100: '#FB5A82',
    200: '#B81A4C',
  },
  primary: {
    100: '#F0F0FF',
    200: '#9412DC',
    150: '#f1ddfc',
    300: '#C570F3',
    400: '#F7E7FF',
    500: '#9412DC',
    700: '#6E2B77',
  },
  secondary: {
    100: '#E0FBF6',
    200: '#41A9B9',
  },
  background: {
    50: '#FAFAFA',
    100: '#F0F1F2',
    200: '#CBD5E0',
    400: '#939DA5',
    700: '#202024',
    800: '#18171B',
    900: '#040c10',
  },
  text: {
    100: '#FFFFFF',
    200: '#acacad',
    300: '#11273a',
    400: '#1F7161',
    600: '#667078',
    700: '#586169',
    900: '#11273A',
  },
};
